import PositionDetails from './components/positionDetails';

function PositionDetailsPage() {
  return <PositionDetails />;
}

export default PositionDetailsPage;
